var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppendOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5002 19.4998H1.9998C1.17281 19.4998 0.5 18.827 0.5 18V1.9998C0.5 1.17281 1.17281 0.5 1.9998 0.5H11.5002C12.3272 0.5 13 1.17281 13 1.9998V9.04911C12.2026 9.3159 11.6284 10.0759 11.6284 10.9467V12.5752H9.9999C8.89693 12.5752 7.9996 13.4725 7.9996 14.5755C7.9996 15.6785 8.89693 16.5758 9.9999 16.5758H11.6284V17.9469C11.6284 18.472 11.8356 18.9666 12.1871 19.3331C11.9769 19.4415 11.7419 19.4998 11.5002 19.4998Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3618 18.9998C11.2109 18.6756 11.1284 18.3173 11.1284 17.9469V17.0758H9.9999C8.62123 17.0758 7.4996 15.9542 7.4996 14.5755C7.4996 13.1968 8.62123 12.0752 9.9999 12.0752H11.1284V10.9467C11.1284 9.98767 11.6857 9.13609 12.5 8.71896V1.9998C12.5 1.44851 12.0515 1 11.5002 1H1.9998C1.44851 1 1 1.44851 1 1.9998V18C1 18.5513 1.44851 18.9998 1.9998 18.9998H11.3618ZM11.5002 19.9998H1.9998C0.89711 19.9998 0 19.1027 0 18V1.9998C0 0.89711 0.89711 0 1.9998 0H11.5002C12.6029 0 13.5 0.89711 13.5 1.9998V9.45276C12.7305 9.51807 12.1284 10.1739 12.1284 10.9467V13.0752H9.9999C9.17263 13.0752 8.4996 13.7482 8.4996 14.5755C8.4996 15.4028 9.17263 16.0758 9.9999 16.0758H12.1284V17.9469C12.1284 18.534 12.4737 19.0704 13.0082 19.3134C12.6274 19.7502 12.0776 19.9998 11.5002 19.9998Z",
    fill: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.5H9.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.5H8.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.5H6.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5996 13.5H10.5996C10.0473 13.5 9.59961 13.9477 9.59961 14.5C9.59961 15.0523 10.0473 15.5 10.5996 15.5H16.5996C17.1519 15.5 17.5996 15.0523 17.5996 14.5C17.5996 13.9477 17.1519 13.5 16.5996 13.5Z",
    fill: "#272D55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5996 11.5V17.5C14.5996 17.7652 14.4943 18.0196 14.3067 18.2071C14.1192 18.3946 13.8648 18.5 13.5996 18.5C13.3344 18.5 13.08 18.3946 12.8925 18.2071C12.705 18.0196 12.5996 17.7652 12.5996 17.5V11.5C12.5996 11.2348 12.705 10.9804 12.8925 10.7929C13.08 10.6054 13.3344 10.5 13.5996 10.5C13.8648 10.5 14.1192 10.6054 14.3067 10.7929C14.4943 10.9804 14.5996 11.2348 14.5996 11.5V11.5Z",
    fill: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppendOperationIcon);
export default __webpack_public_path__ + "static/media/AppendOperationIcon.e60df35ff46c0545474b723c4d620993.svg";
export { ForwardRef as ReactComponent };